// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__MLContactUs__contactUsContainer h5{font-size:26px;font-weight:700}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-gateway-react/MLContactUs/MLContactUs.module.scss"],"names":[],"mappings":"AACI,yCACI,cAAA,CACA,eAAA","sourcesContent":[".contactUsContainer {\n    h5 {\n        font-size: 26px;\n        font-weight: bold;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contactUsContainer": "app__MLContactUs__contactUsContainer"
};
export default ___CSS_LOADER_EXPORT___;
